import { Reducer } from 'redux';
import { ACTION_TYPES, State } from './types';

const initialState: State = {
  containerWidth: 'lg',
};

const reducer: Reducer<State, any> = (state: State = initialState, action): State => {
  const map = {
    [ACTION_TYPES.SET_CONTAINER_WIDTH]: () => ({
      ...initialState,
      containerWidth: action.payload,
    }),
  };

  return typeof map[action.type] === 'function' ? map[action.type]() : state;
};

export default reducer;
